/* ── VERON · „Mehr laden“ auf Kategorieseiten (Saison-Konzept Stufe 3, Paket B, 11.10.2026) ──
   Konzept Kap. 2.4: „Mehr laden“ ersetzt die Seitenzahlen. Die Seitenlinks bleiben im HTML
   (sections/veron-collection.liquid, nav[data-veron-pager]) — für Suchmaschinen und für Besucher
   ohne JavaScript. Erst wenn dieses Skript läuft, werden sie ausgeblendet und der Knopf gezeigt.

   Ablauf je Klick:
     1. Ziel ist der href des Knopfs = paginate.next.url. Shopify trägt Filter und Sortierung in
        diese URL ein, gewählte Filter bleiben also beim Nachladen erhalten.
     2. Abgerufen wird nur die Sektion (Section-Rendering-API: ?section_id=…), nicht die ganze Seite.
     3. Die Karten (.veron-collection__grid > *) werden ans Raster gehängt; der neue „Weiter“-Link
        der geladenen Seite wird das nächste Ziel. Fehlt er, verschwindet der Knopf.
     4. Fokus springt auf die erste neue Karte (tabindex -1; Tastatur, Bildschirmleser), der Stand wird angesagt.
   Schlägt der Abruf fehl, folgt der Browser dem Link wie ohne JavaScript (normale Seite 2).
   Die Kacheln brauchen nichts Neues: Bilderkarussell (veron-card-rail.js) und Merkliste
   (veron-wishlist.js) hören am document; die Merkliste zeichnet nach „veron:wishlist:change“ neu.

   Automatisch nachladen (Fynn 20.10.2026: „wenn man scrollt und an dem Punkt unten ist, zeigt er von selbst mehr an,
   der Button kann bleiben, er sollte vorher schon selber auslösen“):
     * Ein IntersectionObserver beobachtet den Knopfbereich mit VORLAUF px Vorlauf nach unten: Kommt er beim Scrollen in
       diese Zone, lädt die nächste Seite von selbst — bevor man unten ankommt. Der Knopf bleibt sichtbar und klickbar.
     * Automatisch: kein Fokussprung (er risse beim Scrollen die Seite herum) und KEIN Seitenwechsel bei einem Fehler —
       dann endet nur das automatische Nachladen, der Knopf bleibt (Klick verhält sich wie bisher).
     * Ist der Knopfbereich nach dem Anhängen noch in der Zone (kurze Seite, großer Bildschirm), lädt er gleich die
       nächste Seite nach — der Beobachter meldet nur Wechsel, nicht den Zustand.
     * Ohne IntersectionObserver (sehr alte Browser) bleibt es beim Knopf.

   Neu binden (VERON-KOLLEKTIONSFILTER, 31.10.2026): assets/veron-kollektionsfilter.js tauscht nach jedem Filtern das
   Ergebnis (Raster, Knopf, Seitenlinks) ohne Neuladen aus und ruft dann window.veronMehrLadenBinden(sektion) auf. Der alte
   Beobachter wird getrennt, der neue Knopfbereich gebunden (jeder Bereich nur einmal, Merker data-veron-mehr-bereit). */
(function () {
  'use strict';
  if (window.__veronMehrLaden) return;
  window.__veronMehrLaden = true;

  var VORLAUF = 900;

  function binde(sec) {
      if (sec.__veronMehrEnde) { sec.__veronMehrEnde(); sec.__veronMehrEnde = null; }
      var box = sec.querySelector('[data-veron-mehr]');
      var knopf = box && box.querySelector('[data-veron-mehr-knopf]');
      var raster = sec.querySelector('.veron-collection__grid');
      var pager = sec.querySelector('[data-veron-pager]');
      var stand = box && box.querySelector('[data-veron-mehr-stand]');
      var sectionId = sec.getAttribute('data-section-id');
      if (!box || !knopf || !raster || !sectionId || !window.fetch || !window.DOMParser) return;
      if (box.getAttribute('data-veron-mehr-bereit')) return;
      box.setAttribute('data-veron-mehr-bereit', '1');

      box.hidden = false;
      if (pager) pager.classList.add('is-durch-mehr-ersetzt');
      var knopfText = knopf.textContent;
      var laeuft = false;
      var beobachter = null;

      function autoEnde() {
        if (beobachter) { beobachter.disconnect(); beobachter = null; }
      }

      function inZone() {
        if (!box.isConnected || !knopf.isConnected) return false;
        var r = box.getBoundingClientRect();
        return r.top < (window.innerHeight || document.documentElement.clientHeight) + VORLAUF && r.bottom > -VORLAUF;
      }

      function laden(auto) {
        if (laeuft || !knopf.isConnected) return;
        var ziel = knopf.getAttribute('href');
        if (!ziel) return;
        laeuft = true;
        knopf.setAttribute('aria-busy', 'true');
        knopf.textContent = knopf.getAttribute('data-laedt-text') || knopfText;
        var url = new URL(ziel, window.location.href);
        url.searchParams.set('section_id', sectionId);
        var weiterGeht = false;
        fetch(url.toString(), { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var neuRaster = doc.querySelector('.veron-collection__grid');
            var karten = neuRaster ? Array.prototype.slice.call(neuRaster.children) : [];
            if (!karten.length) throw new Error('keine Karten');
            var erste = null;
            karten.forEach(function (k) {
              var n = document.importNode(k, true);
              raster.appendChild(n);
              if (!erste) erste = n;
            });
            var weiter = doc.querySelector('[data-veron-mehr-knopf]');
            var gezeigt = raster.children.length;
            if (stand) {
              var vorlage = knopf.getAttribute('data-stand-text') || '';
              if (vorlage) stand.textContent = vorlage.replace('__G__', String(gezeigt));
            }
            if (weiter && weiter.getAttribute('href')) {
              knopf.setAttribute('href', weiter.getAttribute('href'));
              knopf.textContent = knopfText;
              weiterGeht = true;
            } else {
              knopf.remove();
              autoEnde();
            }
            try { document.dispatchEvent(new CustomEvent('veron:wishlist:change')); } catch (err) { /* alt */ }
            // Fokus auf die erste neue Karte (Tastatur, Bildschirmleser). Der Kartenlink hat display: contents und ist
            // in Chrome nicht fokussierbar - darum die Karte selbst (tabindex -1), gemessen 11.10.2026.
            // Nur beim Klick - beim automatischen Nachladen bleibt der Fokus, wo er ist.
            if (erste && !auto) {
              erste.setAttribute('tabindex', '-1');
              erste.focus({ preventScroll: true });
            }
          })
          .catch(function () {
            if (!auto) { window.location.href = ziel; return; }
            autoEnde();
            if (knopf.isConnected) knopf.textContent = knopfText;
          })
          .then(function () {
            laeuft = false;
            if (knopf.isConnected) knopf.removeAttribute('aria-busy');
            if (weiterGeht && beobachter && inZone()) window.setTimeout(function () { laden(true); }, 150);
          });
      }

      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        laden(false);
      });

      if ('IntersectionObserver' in window) {
        beobachter = new IntersectionObserver(function (eintraege) {
          for (var i = 0; i < eintraege.length; i++) {
            if (eintraege[i].isIntersecting) { laden(true); return; }
          }
        }, { rootMargin: '0px 0px ' + VORLAUF + 'px 0px' });
        beobachter.observe(box);
      }
      sec.__veronMehrEnde = function () { autoEnde(); laeuft = true; };
  }
  window.veronMehrLadenBinden = binde;
  function start() {
    document.querySelectorAll('[data-veron-collection]').forEach(binde);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
